export default "__VITE_ASSET__U__Y_jnV__ 100w";